import { SearchResponse } from 'src/pages/api/search';
import { searchFetcher } from 'src/utilities/searchFetcher';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import { useSiteContext } from 'src/store';

const useSearchData = (
  page: number,
  pageSize: number,
  containerId?: string,
  additionalQueryParams?: string
) => {
  const router = useRouter();
  const {
    tenantId,
    packageId,
    appContainerId,
    accreditations: accreditationsConfig,
    includeAllCommissionableApps,
  } = useSiteContext();

  const includeAllCommissionableAppsQuery = includeAllCommissionableApps
    ? '&includeAllCommissionableApps=true'
    : '';

  const apiUrl = `/api/search?tenantId=${tenantId}&packageId=${packageId}&containerId=${
    containerId ?? appContainerId
  }&page=${page}&pageSize=${pageSize}${additionalQueryParams}${includeAllCommissionableAppsQuery}`;

  const shouldFetch = router.isReady && tenantId && packageId && appContainerId;
  const fetcher = (url: string) => searchFetcher(url, accreditationsConfig);
  const { data, error, isLoading } = useSWR<SearchResponse>(
    shouldFetch ? apiUrl : null,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    searchResults: data?.searchResults,
    isLoading,
    error,
  };
};

export default useSearchData;
